/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Limit_1_ValueInputs */

const en_svc_research_limit_1_value = /** @type {(inputs: Svc_Research_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every statement in a brief links to where it came from.`)
};

const lv_svc_research_limit_1_value = /** @type {(inputs: Svc_Research_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katrs apgalvojums kopsavilkumā norāda, no kurienes tas nāk.`)
};

/**
* | output |
* | --- |
* | "Every statement in a brief links to where it came from." |
*
* @param {Svc_Research_Limit_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_limit_1_value = /** @type {((inputs?: Svc_Research_Limit_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Limit_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_limit_1_value(inputs)
	return en_svc_research_limit_1_value(inputs)
});